//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { axiosGet, axiosPost } from '../../../../axios/axios.js'
import { createFieldConfig } from '../../../../components/QSelectUtils.js'
import CardPropertyTable from '../../../../components/Card/CardPropertyTable.vue'

export default {
  components: {
    CardPropertyTable
  },
  props: {
    report: {
      default: null,
      type: Object
    },
    resultValue: {
      type: Object,
      default () {
        return {}
      }
    },
    reportActionsAccess: {
      type: Object,
      default () {
        return {}
      }
    },
    readonly: {
      type: Boolean,
      default: false
    },
    dispatcherInterface: {
      type: Boolean,
      default: false
    },
    serviceObject: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data: function () {
    return {
      loading: false,

      reportDirTable: {
        dirTable: null,
        prop: null
      },
      serviceObjectDirTable: {
        dirTable: null,
        prop: null
      },

      dirTypeFieldConfig: createFieldConfig({ allRecordsFn: this.getDirTypes }),
      countdownFieldConfig: createFieldConfig({ allRecordsFn: this.getCountdowns })
    }
  },
  created: function () {
    this.getServiceObjectDirTable()
    this.getDirTableProps()
    this.reportDirTable.dirTable = this.resultValue.value
  },
  methods: {
    onEditRecord: function ({ row, index }) {
      this.$d_ask({
        callback: (data, action) => {
          if (action === 'yes') {
            this.serviceObjectDirTable.prop.tablecolumns.name.forEach(key => {
              this.resultValue.value[key].splice(index, 1, data[key])
            })
          }
        },
        header: 'Редактировать направление?',
        propsConfig: {
          dirNum: {
            type: 'number',
            label: 'Номер направления',
            required: true,
            value: row.dirNum
          },
          dirType: {
            label: 'Тип направления',
            type: 'object',
            searchConfig: this.dirTypeFieldConfig,
            value: row.dirType
          },
          lights: {
            type: 'text',
            label: 'Светофоры',
            value: row.lights
          },
          countdownRed: {
            label: 'ТООВ. красный',
            type: 'object',
            searchConfig: this.countdownFieldConfig,
            value: row.countdownRed
          },
          countdownGreen: {
            label: 'ТООВ. зелёный',
            type: 'object',
            searchConfig: this.countdownFieldConfig,
            value: row.countdownGreen
          }
        },
        buttons: {
          yes: 'Подтвердить',
          cancel2: 'Отмена'
        }
      })
    },
    onAddRecord: function () {
      this.$d_ask({
        callback: (data, action) => {
          if (action === 'yes') {
            this.serviceObjectDirTable.prop.tablecolumns.name.forEach(key => {
              this.resultValue.value[key].push(data[key])
            })
          }
        },
        header: 'Добавить направление?',
        propsConfig: {
          dirNum: {
            type: 'number',
            label: 'Номер направления',
            required: true
          },
          dirType: {
            label: 'Тип направления',
            type: 'object',
            searchConfig: this.dirTypeFieldConfig
          },
          lights: {
            type: 'text',
            label: 'Светофоры'
          },
          countdownRed: {
            label: 'ТООВ. красный',
            type: 'object',
            searchConfig: this.countdownFieldConfig
          },
          countdownGreen: {
            label: 'ТООВ. зелёный',
            type: 'object',
            searchConfig: this.countdownFieldConfig
          }
        },
        buttons: {
          yes: 'Подтвердить',
          cancel2: 'Отмена'
        }
      })
    },
    onCopy: function () {
      this.serviceObjectDirTable.prop.tablecolumns.name.forEach(key => {
        this.resultValue.value[key] = []
      })
      this.serviceObjectDirTable.prop.tablecolumns.name.forEach(key => {
        this.resultValue.value[key].push(...this.serviceObjectDirTable.dirTable[key])
      })
    },
    onActualize: function () {
      if (this.serviceObject) {
        this.loading = true
        const bodyFormData = new FormData()
        bodyFormData.set('id', this.serviceObject.id)
        bodyFormData.set('merge', 'error')
        bodyFormData.set('props', JSON.stringify({ dirTable: this.resultValue.value }))

        return axiosPost({
          url: 'service/obj/setproperties',
          data: bodyFormData,
          onSuccess: () => {
            this.$q.notify({
              type: 'positive',
              message: 'Успешная актуализация',
              progress: true,
              timeout: 3000
            })

            this.getServiceObjectDirTable()
          },
          onFailure: 'Ошибка актуализации'
        }).finally(() => {
          this.loading = false
        })
      }
    },
    getDirTypes: function () {
      return this.getObjects('dirType')
    },
    getCountdowns: function () {
      return this.getObjects('countdownRed')
    },
    getObjects: function (name) {
      if (this.serviceObjectDirTable && this.serviceObjectDirTable.prop) {
        const index = this.serviceObjectDirTable.prop.tablecolumns.name.indexOf(name)
        if (index !== -1) {
          const listvalues = this.serviceObjectDirTable.prop.tablecolumns.listvalues[index]
          const objects = []
          listvalues.value.forEach((v, i) => {
            objects.push({ id: v, name: listvalues.name[i] })
          })
          return Promise.resolve(objects)
        }
      }
    },
    getServiceObjectDirTable: function () {
      if (this.serviceObject) {
        this.loading = true

        const params = [{ param: 'dirTable', type: 'table', action: 'any' }]

        const encodeParams = encodeURIComponent(JSON.stringify(params))
        return axiosGet({
          url: '/service/obj/search?nameField=name&paramsOperation=and&params=' + encodeParams + '&name=id=' + this.serviceObject.id,
          onSuccess: (response) => {
            this.serviceObjectDirTable.dirTable = response.data.result[0]['param.dirTable']
          }
        }).finally(() => {
          this.loading = false
        })
      }
    },
    getDirTableProps: function () {
      this.loading = true
      return axiosGet({
        url: '/service/sysobj/typeparam?type=lights&property=dirTable',
        onSuccess: (response) => {
          this.serviceObjectDirTable.prop = response.data
          this.serviceObjectDirTable.prop._nameUpperCase = 'Таблица направлений в карточке объекта'.toUpperCase()
          this.serviceObjectDirTable.prop.key = this.serviceObjectDirTable.prop.code
          this.serviceObjectDirTable.prop.editable = false

          this.reportDirTable.prop = JSON.parse(JSON.stringify(this.serviceObjectDirTable.prop))
          this.reportDirTable.prop._nameUpperCase = 'Таблица направлений в отчёте'.toUpperCase()
          this.reportDirTable.prop.editable = true
          this.reportDirTable.prop._displayBtnEdit = true
        }
      }).finally(() => {
        this.loading = false
      })
    }
  }
}

